import React, { useContext, useEffect, useState } from "react";
import { Location, useLocation, useNavigate, useParams } from "react-router-dom";
// import { SKChannel, State } from "../../../models/SKChannel";
import { useNavigationBar } from "../../context/NavigationContext";
import { format } from "date-fns";
import * as Yup from "yup";
import {
  SKChannel,
  ChannelState,
  ChannelSubstate,
  ActionItem,
  ActionOnItem,
  getAdminActionableItems,
  getChannelStatusString,
  getAdminActionableEditItems,
  Tier,
} from "../../models/SKChannel";
import { getChannel, updateChannelStatus, updateChannel, updateChannelHistory, deleteChannel } from "../../api/channels/channelServices";
import { capitalizeFirstLetter, getCountryName, getLanguageName, pluralize } from "../../utils/stringFunctions";
import { ModeratorChannelContext } from "../../context/ModerationChannelContext";
import { getUser } from "../../api/accounts/userServices";
import ActionPopup from "../../components/ActionPopup";
import ArtifactModerationDialog from "../contentModeration/ArtifactModerationDialog";
import ArtifactStateDialog, { DialoageContent } from "../artifacts/create/container/components/ArtifactStateDialog";
import { CreateChannelContext } from "../../context/CreateChannelContext";
import HistoryNavigator from "./HistoryNavigator";
import ChannelCheckListCard from "../channels/create/components/ChannelCheckListCard";
import { AddTextField } from "../../components/AddTextField";
import { AddTextAreaField } from "../../components/AddTextAreaField";
import ImageInput from "../artifacts/create/ImageInput";
import { SKSelectOption } from "../../components/SKSelectOption";
import { iso6392 } from "iso-639-2";
import { iso31661 } from "iso-3166";
import ChannelEditNavigator from "./ChannelEditNavigator";
import { useUpdateList } from "./UpdateListContext";
import { TopicTypeString } from "../../models/SKArtifact";
import { ChannelPublishingTier } from "../channels/create/ChannelPublishingTier";
import ChannelReportNavigator from "./ChannelReportNavigator";
import { customCountryNames, List_of_countries_to_be_displayed } from "../../utils/countryCodes";
import { hasAnyRole, useAuth, UserRole } from "../../context/AuthContext";
import { ChannelSubscriptionIds } from "../channels/create/ChannelSubscriptionIds";
import { ChannelSubscriptionType } from "../channels/create/ChannelSubscriptionType";
import OptionSelect from "../../components/OptionSelect";
import PopupSingleButton, { PopupActionStatus, PopupContent } from "../../components/PopupSingleButton";
import { PrimaryExternalLinkData } from "../../utils";

// const options_preApproval = [
//   { title: "Request for more Information", value: "Request for more Information" },
//   { title: "Not Supported", value: "Not Supported" },
//   { title: "Do not meet Guidelines", value: "Do not meet Guidelines" },
//   { title: "Multiple Non Approvals", value: "Multiple Non Approvals" },
//   { title: "Misleading or False Information", value: "Misleading or False Information" },
//   { title: "Spam", value: "Spam" },
//   { title: "Obscene or Explicit Language", value: "Obscene or Explicit Language" },
//   { title: "Privacy Violation", value: "Privacy Violation" },
//   { title: "Copyright Infringement or Illegal", value: "Copyright Infringement or Illegal" },
//   { title: "Other", value: "Other" },
// ]

// const options_block = [
//   { title: "Made in Error", value: "Made in Error" },
//   { title: "Wrong Decision", value: "Wrong Decision" },
//   { title: "Issue Addressed", value: "Issue Addressed" },
//   { title: "Guideline Changed", value: "Guideline Changed" },
//   { title: "Other", value: "Other" },
// ];

const reasons_code = [
  {
    title: "Request for more Information",
    value: "Request for more Information",
    code: "R0001",
  },
  { title: "Not Supported", value: "Not Supported", code: "R0002" },
  {
    title: "Do not meet Guidelines",
    value: "Do not meet Guidelines",
    code: "R0003",
  },
  {
    title: "Multiple Non Approvals",
    value: "Multiple Non Approvals",
    code: "R0004",
  },
  { title: "Violent or Gore", value: "Violent or Gore", code: "R0005" },
  {
    title: "Hate Speech or Discrimination",
    value: "Hate Speech or Discrimination",
    code: "R0006",
  },
  {
    title: "Harassment or Bullying",
    value: "Harassment or Bullying",
    code: "R0007",
  },
  {
    title: "Nudity or Sexual Acts",
    value: "Nudity or Sexual Acts",
    code: "R0008",
  },
  {
    title: "Misleading or False Information",
    value: "Misleading or False Information",
    code: "R0009",
  },
  {
    title: "Abusive or Exploitive",
    value: "Abusive or Exploitive",
    code: "R0010",
  },
  { title: "Spam", value: "Spam", code: "R0011" },
  {
    title: "Obscene or Explicit Language",
    value: "Obscene or Explicit Language",
    code: "R0012",
  },
  { title: "Privacy Violation", value: "Privacy Violation", code: "R0013" },
  {
    title: "Copyright Infringement or Illegal",
    value: "Copyright Infringement or Illegal",
    code: "R0014",
  },
  { title: "Other", value: "Other", code: "R0015" },
];

const List_of_languages_to_be_displayed = [
  "Afrikaans",
  "Akan",
  "Albanian",
  "Amharic",
  "Arabic",
  "Armenian",
  "Assamese",
  "Aymara",
  "Azerbaijani",
  "Bashkir",
  "Basque",
  "Belarusian",
  "Bengali",
  "Bhojpuri",
  "Bosnian",
  "Breton",
  "Bulgarian",
  "Burmese",
  "Catalan",
  "Cebuano",
  "Chamorro",
  "Chichewa",
  "Chinese (Simplified)",
  "Chinese (Traditional)",
  "Chuvash",
  "Corsican",
  "Cree",
  "Croatian",
  "Czech",
  "Danish",
  "Dari",
  "Divehi",
  "Dogri",
  "Dutch",
  "Dzongkha",
  "English",
  "Esperanto",
  "Estonian",
  "Ewe",
  "Fijian",
  "Filipino (Tagalog)",
  "Finnish",
  "Flemish",
  "French",
  "Frisian",
  "Fulah",
  "Galician",
  "Georgian",
  "German",
  "Greek",
  "Guarani",
  "Gujarati",
  "Haitian Creole",
  "Hausa",
  "Hawaiian",
  "Hebrew",
  "Hindi",
  "Hmong",
  "Hungarian",
  "Icelandic",
  "Igbo",
  "Ilocano",
  "Indonesian",
  "Inuktitut",
  "Irish",
  "Italian",
  "Japanese",
  "Javanese",
  "Kannada",
  "Kazakh",
  "Khmer",
  "Kinyarwanda",
  "Kirghiz",
  "Konkani",
  "Korean",
  "Kurdish",
  "Lao",
  "Latin",
  "Latvian",
  "Lingala",
  "Lithuanian",
  "Luxembourgish",
  "Macedonian",
  "Malagasy",
  "Malay",
  "Malayalam",
  "Maltese",
  "Maori",
  "Marathi",
  "Mongolian",
  "Manipuri",
  "Nepali",
  "Norwegian",
  "Nyanja",
  "Odia (Oriya)",
  "Ojibwe",
  "Pashto",
  "Persian (Farsi)",
  "Polish",
  "Portuguese",
  "Punjabi",
  "Quechua",
  "Romanian",
  "Romansh",
  "Russian",
  "Samoan",
  "Sanskrit",
  "Scots Gaelic",
  "Serbian",
  "Sesotho",
  "Shona",
  "Sindhi",
  "Sinhala",
  "Slovak",
  "Slovenian",
  "Somali",
  "Spanish",
  "Sundanese",
  "Swahili",
  "Swedish",
  "Tahitian",
  "Tajik",
  "Tamil",
  "Tatar",
  "Telugu",
  "Thai",
  "Tibetan",
  "Tigrinya",
  "Tok Pisin",
  "Tswana",
  "Turkish",
  "Turkmen",
  "Ukrainian",
  "Urdu",
  "Uyghur",
  "Uzbek",
  "Vietnamese",
  "Volapük",
  "Walloon",
  "Welsh",
  "Wolof",
  "Xhosa",
  "Yiddish",
  "Yoruba",
  "Zulu",
];

export const ChannelDetail = () => {
  const sortedExternalLinkOptions = PrimaryExternalLinkData.map(link => ({
    title: link.title,
    value: link.type,
  }));

  const authContext = useAuth();
  const { channelData, updateChannelData, setChannelId, updateStatus, loading, isEditReview, originalSubstate, updateDataOnServer } =
    useContext(ModeratorChannelContext);
  const [actionOnItem, setActionOnItem] = useState<ActionOnItem | null>(null);
  const [dialogContent, setDialogContent] = useState<DialoageContent | null>(null);
  const [enableApproval, setEnableApproval] = useState(false);
  const [showIdsAlert, setShowIdsAlert] = useState(false);
  // const [options, setOptions] = useState(options_normal);
  const { setNavProps } = useNavigationBar();
  const location = useLocation();

  const moderationDialogActions = [ActionItem.reject, ActionItem.delete, ActionItem.withdraw, ActionItem.deactive, ActionItem.reject_edit];
  const navigate = useNavigate();
  const { id } = useParams();

  const { updateList } = useUpdateList();

  // const isoLanguages = [
  //   { title: "English", value: "eng" },
  //   ...iso6392
  //     .filter((lang) => lang.iso6392B !== "eng")
  //     .map((lang) => ({
  //       title: lang.name,
  //       value: lang.iso6392B,
  //     }))
  //     .sort((a, b) => a.title.localeCompare(b.title)),
  // ];

  const isoLanguages = [
    { title: "English", value: "eng" },
    ...iso6392
      .filter(lang => List_of_languages_to_be_displayed.includes(lang.name))
      .map(lang => ({
        title: lang.name,
        value: lang.iso6392B,
      }))
      .sort((a, b) => a.title.localeCompare(b.title)),
  ];

  const isoCountries = [
    { title: "United States", value: "USA" },
    ...iso31661
      .filter(country => List_of_countries_to_be_displayed.includes(country.name))
      .map(country => ({
        title: customCountryNames[country.name] || country.name,
        value: country.alpha3,
      }))
      .sort((a, b) => a.title.localeCompare(b.title)),
  ];

  // const isoCountries = [
  //   { title: "United States", value: "USA" },
  //   ...iso31661
  //     .filter((country) => country.alpha3 !== "USA")
  //     .map((country) => ({ title: country.name, value: country.alpha3 }))
  //     .sort((a, b) => a.title.localeCompare(b.title)),
  // ];

  const schema = Yup.object().shape({
    subscriptionStatus: Yup.mixed<Tier>().required(""),
    appleMonthlySubscriptionId: Yup.string().when("subscriptionStatus", {
      is: (val: Tier) => val === Tier.paid || val === Tier.freeNpaid,
      then: schema => schema.required("Apple Monthly Subscription ID is required "),
      otherwise: schema => schema.nullable(),
    }),
    appleYearlySubscriptionId: Yup.string().when("subscriptionStatus", {
      is: (val: Tier) => val === Tier.paid || val === Tier.freeNpaid,
      then: schema => schema.required("Apple Yearly Subscription ID is required "),
      otherwise: schema => schema.nullable(),
    }),
    googleSubscriptionGroup: Yup.string().when("subscriptionStatus", {
      is: (val: Tier) => val === Tier.paid || val === Tier.freeNpaid,
      then: schema => schema.required("Goole Monthly Subscription Group is required "),
      otherwise: schema => schema.nullable(),
    }),
    googleMonthlySubscriptionId: Yup.string().when("subscriptionStatus", {
      is: (val: Tier) => val === Tier.paid || val === Tier.freeNpaid,
      then: schema => schema.required("Google Monthly Subscription ID is required "),
      otherwise: schema => schema.nullable(),
    }),
    googleYearlySubscriptionId: Yup.string().when("subscriptionStatus", {
      is: (val: Tier) => val === Tier.paid || val === Tier.freeNpaid,
      then: schema => schema.required("Google Yearly Subscription ID is required "),
      otherwise: schema => schema.nullable(),
    }),
  });

  useEffect(() => {
    // const { channelId } = location.state;
    id && setChannelId(id);
    console.log(location.pathname);
    //setArtifactId(containerId);
  }, [id, isEditReview]);

  useEffect(() => {
    const validateAll = async (cdata: SKChannel) => {
      const {
        subscriptionStatus,
        appleMonthlySubscriptionId,
        appleYearlySubscriptionId,
        googleSubscriptionGroup,
        googleMonthlySubscriptionId,
        googleYearlySubscriptionId,
      } = cdata;
      try {
        await schema.validate(
          {
            subscriptionStatus,
            appleMonthlySubscriptionId,
            appleYearlySubscriptionId,
            googleSubscriptionGroup,
            googleMonthlySubscriptionId,
            googleYearlySubscriptionId,
          },
          { abortEarly: false }
        );
        setEnableApproval(true);
      } catch (error) {
        setEnableApproval(false);
      }
    };

    if (channelData) {
      validateAll(channelData);
    }
  }, [channelData, schema]);

  // const [channelState, setChannelState] = useState({ key: "", value: "" });

  const getPopItemsForId = (): ActionItem[] => {
    if (channelData) {
      const { status, subStatus } = channelData;
      return isEditReview && originalSubstate && originalSubstate === ChannelSubstate.EDIT_IN_REVIEW
        ? getAdminActionableEditItems({
            state: status,
            subState: originalSubstate,
          })
        : getAdminActionableItems({ state: status, subState: subStatus });
    }
    return [];
  };

  // function getActionableItems(content: SKChannel): ActionItem[] {
  //   const actions: { [key in ChannelState]: ActionItem[] } = {
  //     draft: [],
  //     review: [ActionItem.approve, ActionItem.do_not_approve, ActionItem.block],
  //     published: [ActionItem.make_inactive, ActionItem.block],
  //     approved: [],
  //     pre_approved: [],
  //     rejected: [ActionItem.active, ActionItem.delete],
  //     need_more_info: [],
  //     blocked: [ActionItem.remove_block, ActionItem.delete],
  //     suspended: [ActionItem.remove_suspension, ActionItem.delete],
  //   };

  //   return actions[content.status] || [];
  // }

  useEffect(() => {
    channelData?.id &&
      setNavProps({
        backArrow: false,
        title: channelData.name || "",
        subtitle: "",
        userActions: `${pluralize(channelData.followerCount ?? 0, "Follower")}`,
        buttonTitle: "",
        enableLink: true,
        getActionItems: getPopItemsForId,
        onActionItemSelect: actionItem => {
          if (actionItem === ActionItem.approve || actionItem === ActionItem.approve_edit) {
            if (enableApproval) {
              setActionOnItem({
                itemid: channelData.id!,
                action: actionItem as ActionItem,
              });
            } else {
              //alert("Please enter subscription IDs");
              setShowIdsAlert(true);
            }
          } else {
            setActionOnItem({
              itemid: channelData.id!,
              action: actionItem as ActionItem,
            });
          }
        },
        onClose: () => {
          navigate(-1);
        },
      });
  }, [setNavProps, channelData, enableApproval]);

  function getModerationDialogContent(action: ActionItem): DialoageContent | null {
    switch (action) {
      case ActionItem.delete:
        return {
          message: "Are you sure you will like to Delete Channel?",
          description: "Permanently delete this channel. This action cannot be undone.",
          actionTitle: ActionItem.delete,
          destructiv: true,
        };
      case ActionItem.reject:
        return {
          message: "Are you sure you will like to Reject Channel?",
          description: "This channel will not be published to the users.",
          actionTitle: ActionItem.reject,
          destructiv: true,
        };

      case ActionItem.deactive:
        return {
          message: "Are you sure you will like to Deactivate Channel?",
          description: "Users will not be able to view this channel anymore.",
          actionTitle: ActionItem.deactive,
          destructiv: true,
        };
      case ActionItem.withdraw:
        return {
          message: "Are you sure you will like to Withdraw Channel?",
          description: "Users will not be able to view this channel anymore.",
          actionTitle: ActionItem.withdraw,
          destructiv: true,
        };
      case ActionItem.reject_edit:
        return {
          message: "Are you sure you will like to Reject Edits?",
          description: "Channel edits will be discarded. This action cannot be undone.",
          actionTitle: ActionItem.reject_edit,
          destructiv: true,
        };
      case ActionItem.approve:
        return {
          message: "Are you sure you will like to Approve Channel?",
          description: "This will publish the channel and make it visible to the users.",
          actionTitle: ActionItem.approve,
          destructiv: false,
        };
      case ActionItem.approve_edit:
        return {
          message: " Are you sure you will like to Approve Channel edits?",
          description: "Edits will be immediatly available to the public.",
          actionTitle: ActionItem.approve_edit,
          destructiv: false,
        };

      default:
        return null;
    }
  }

  useEffect(() => {
    if (actionOnItem?.action) {
      const contentDialog = getModerationDialogContent(actionOnItem.action);
      setDialogContent(contentDialog);
    }
  }, [actionOnItem]);

  const popupContent: PopupContent = {
    title: "Missing Subscription IDs",
    message: "Add valid subscription product IDs for Apple and Google in the channel settings.",
    buttonTitle: "OK",
    status: PopupActionStatus.failed,
  };

  return channelData ? (
    <>
      {showIdsAlert && (
        <PopupSingleButton
          onClose={() => {
            setShowIdsAlert(false);
          }}
          popupContent={popupContent}
        />
      )}
      {actionOnItem?.action && dialogContent ? (
        moderationDialogActions.includes(actionOnItem.action) ? (
          <ArtifactModerationDialog
            contentId={actionOnItem.itemid}
            action={actionOnItem.action}
            onAction={async (contentId, action, reason, note) => {
              // update status now
              updateStatus && (await updateStatus(contentId, action as ActionItem, reason, note));

              // updateStatus(contendId, action as ActionItem, reason, note);
              updateList(contentId, action as ActionItem);
              setActionOnItem(null);
            }}
            onCancel={() => setActionOnItem(null)}
            options={reasons_code}
            dialogContent={dialogContent}
          />
        ) : (
          <ArtifactStateDialog
            action={actionOnItem?.action}
            onClose={() => setActionOnItem(null)}
            onUpdate={async () => {
              const action = actionOnItem?.action;
              const contentId = actionOnItem?.itemid;

              // Save subscription ids and group
              // if (action !== ActionItem.reject_edit) {
              channelData &&
                (channelData.subscriptionStatus === Tier.paid || channelData.subscriptionStatus === Tier.freeNpaid) &&
                updateDataOnServer &&
                (await updateDataOnServer());
              // }

              // update status now
              updateStatus && (await updateStatus(contentId, action));
              updateList(contentId, action as ActionItem);
              setActionOnItem(null);
            }}
            dialogeContent={dialogContent}
          />
        )
      ) : (
        <></>
      )}
      <div className="flex flex-col gap-[30px] channel-page-context">
        {!isEditReview && channelData.id && channelData.status === ChannelState.ACTIVE && channelData.subStatus === ChannelSubstate.EDIT_IN_REVIEW ? (
          <ChannelEditNavigator title="Channel Edit" docId={channelData.id} />
        ) : (
          ""
        )}

        {!isEditReview && channelData.id && !(channelData.status === ChannelState.DRAFT && channelData.subStatus === ChannelSubstate.NONE) ? (
          <HistoryNavigator
            title="Channel Status"
            docId={channelData.id}
            channelStatus={getChannelStatusString(channelData.status, channelData.subStatus)}
          />
        ) : (
          ""
        )}

        {!isEditReview && channelData.id && !(channelData.status === ChannelState.DRAFT && channelData.subStatus === ChannelSubstate.NONE) ? (
          <ChannelReportNavigator title="Channel Status" />
        ) : (
          ""
        )}

        <div className="flex flex-col space-y-[10px] w-full">
          <div className="flex items-center">
            <AddTextField
              name={"name"}
              title={"Channel Name"}
              note={"This is the public name of your channel."}
              placeholder={"Name"}
              index={1}
              charAllowed={30}
              value={channelData.name}
              isCloseBtn={false}
              onChange={() => {}}
              onFocus={() => {}}
              onBlur={e => {}}
              notesclass="notes_inner_page"
              disabled={true}
            />
          </div>
        </div>
        <div className="flex flex-col space-y-[10px] w-full">
          <div className="relative w-full min-w-[200px] mb-2">
            <AddTextAreaField
              index={2}
              name={"description"}
              title={"Channel Description"}
              note={"Share a brief description about your channel and content."}
              placeholder={"Enter Description"}
              height={150}
              charAllowed={500}
              value={channelData.description as string}
              onChange={() => {}}
              // notesclass="notes_inner_page"
              disabled={true}
            />
          </div>
        </div>
        <div className="flex flex-col w-full">
          <div>
            <div className="flex items-center">
              <span>
                <span className="content_count">3</span>
              </span>
              <span className="content_title">Channel Profile Photo</span>
            </div>
            <div>
              <label className="notes_inner_page">Recommended resolution 360 x 360.</label>
            </div>

            <div className="mt-[15px] rounded-[12px]">
              <img
                src={channelData.profileImageUrl}
                alt="Profile"
                className="object-cover w-full h-full"
                style={{
                  width: `${180}px`,
                  height: `${180}px`,
                  overflow: "hidden",
                  // borderRadius: "12px",
                }}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col w-full">
          <div className="flex items-center">
            <span>
              <span className="content_count">4</span>
            </span>
            <span className="content_title">Channel Background Photo</span>
          </div>
          <div>
            <label className="notes_inner_page">Recommended resolution 780 x 260.</label>
          </div>
          <div className="mt-[15px] rounded-[12px]">
            <img
              src={channelData.backgroundImageUrl}
              alt="Background"
              className="object-cover w-full h-[100px] sm:h-[150px]"
              style={{
                // width: `${450}px`,
                // height: `${150}px`,
                // overflow: "hidden",
                overflow: "hidden",
                // borderRadius: "12px",
              }}
            />
          </div>
        </div>
        <div className="flex flex-col w-full">
          <div>
            <div className="flex items-center">
              <span>
                <span className="content_count">5</span>
              </span>
              <span className="content_title">Add Promotional Photo</span>
            </div>
            <div>
              <label className="notes_inner_page">
                We may show this photo on your subscription paywall and in key promotional areas. Recommended aspect ratio of photo is either 4:3,
                1:1, or 3:4.
              </label>
            </div>

            <div className="mt-[15px] rounded-[12px]">
              <img
                src={channelData.promoMediaURL}
                alt="Promo Media"
                className="object-cover w-full h-full"
                style={{
                  width: `${180}px`,
                  height: `${180}px`,
                  overflow: "hidden",
                  // borderRadius: "12px",
                }}
              />
            </div>
          </div>
        </div>
        <div className="items-center lex">
          <div className="flex items-center">
            <SKSelectOption
              index={6}
              name="language"
              value={channelData.language}
              heading="Channel Languages"
              subHeading={"Choose the primary language of your channel. You can still post in other languages."}
              width={"w-[290px]"}
              options={isoLanguages}
              onUpdate={() => {}}
              marginBottom="mb-[15px]"
              editable={false}
            />
          </div>

          <div className="flex items-center">
            <SKSelectOption
              name="secondLanguage"
              value={channelData.secondLanguage || "None"}
              heading=""
              subHeading={"Choose the secondary language of your channel if applicable."}
              width={"w-[290px]"}
              options={[{ title: "Optional", value: "optional" }, ...isoLanguages]}
              onUpdate={e => {}}
              marginBottom="mb-[0px]"
              editable={false}
            />
          </div>
        </div>

        <div className="flex items-center">
          <SKSelectOption
            index={7}
            value={channelData.country}
            name="country"
            heading="Channel's Home Country"
            subHeading={"Choose the the home country where you channel is based."}
            width={"w-[290px]"}
            options={isoCountries}
            onUpdate={e => {}}
            marginBottom="mb-[0px]"
            editable={false}
          />
        </div>
        <div className="flex flex-col w-full">
          <div className="relative inline-block w-full text-left">
            <SKSelectOption
              id="Link_1"
              index={8}
              // value={channelData.externalLinks?.[0]?.type || "web_social"}
              value={channelData.externalLinks?.[0]?.type ?? "web_social"}
              heading="External Links"
              subHeading="Choose important external links you would like your followers to have access to."
              width="w-[290px]"
              options={[{ title: "Website", value: "web_social" }, ...sortedExternalLinkOptions]}
              //options={sortedExternalLinkOptions}
              selectedIndex={1}
              onUpdate={e => {}}
              marginBottom="mb-[15px]"
              editable={false}
            />
          </div>
          <div className="flex items-center">
            <AddTextField
              id={"primaryExternalLink"}
              name={"primaryExternalLink"}
              title={""}
              note={""}
              placeholder={"Add Link"}
              charAllowed={50}
              value={channelData.externalLinks?.[0]?.value ?? ""}
              isCloseBtn={false}
              onChange={async e => {}}
              showRemainingChar={false}
              disabled={true}
            />
          </div>
        </div>
        <div className="flex flex-col w-full">
          <div className="relative inline-block w-8/12 text-left">
            <SKSelectOption
              id="Link_2"
              value={channelData.externalLinks?.[1]?.type || "None"}
              selectedIndex={2}
              heading=""
              subHeading={""}
              width={"w-[290px]"}
              options={[{ title: "None", value: "None" }, ...sortedExternalLinkOptions]}
              onUpdate={e => {}}
              marginBottom="mb-[15px]"
              editable={false}
            />
          </div>

          <div className="flex items-center">
            <AddTextField
              id={"secondaryExternalLink"}
              name={"secondaryExternalLink"}
              title={""}
              note={""}
              placeholder={"Add Link"}
              charAllowed={50}
              value={channelData.externalLinks?.[1]?.value ?? ""}
              isCloseBtn={false}
              onChange={async e => {}}
              showRemainingChar={false}
              disabled={true}
            />
          </div>
        </div>
        <div className="flex flex-col w-full">
          <div className="relative inline-block w-8/12 text-left">
            <SKSelectOption
              id="Link_3"
              value={channelData.externalLinks?.[2]?.type || "None"}
              selectedIndex={3}
              heading=""
              subHeading={""}
              width={"w-[290px]"}
              options={[{ title: "None", value: "None" }, ...sortedExternalLinkOptions]}
              onUpdate={e => {}}
              marginBottom="mb-[15px]"
              editable={false}
            />
          </div>

          <div className="flex items-center">
            <AddTextField
              id={"otherExternalLink"}
              name={"otherExternalLink"}
              title={""}
              note={""}
              placeholder={"Add Link"}
              charAllowed={50}
              value={channelData.externalLinks?.[2]?.value ?? ""}
              isCloseBtn={false}
              onChange={async e => {}}
              showRemainingChar={false}
              disabled={true}
            />
          </div>
        </div>
        <ChannelCheckListCard
          index={9}
          name="Topic"
          title="Topic"
          purposeText="Add Topic"
          notes="Topic that represents the primary focus of channel content."
          doneText={channelData.topic ? capitalizeFirstLetter(TopicTypeString[channelData.topic]) : undefined}
          action={() => {}}
          disabled={true}
        />
        <ChannelCheckListCard
          index={10}
          name="Age Rating"
          title="Age Rating"
          purposeText="Add Age Rating"
          notes="Safety age rating for children."
          doneText={channelData.age ? "Age " + channelData.age + "+" : undefined}
          action={() => {}}
          disabled={true}
        />
        <ChannelCheckListCard
          index={11}
          name="Channel Safety"
          title="Channel Safety"
          purposeText="Certify Content"
          notes="Certify that your content is safe and follows Skarvo Content Guidelines."
          doneText={channelData.certifyFirst && channelData.certifySecond ? "Certified" : undefined}
          action={() => {}}
          disabled={true}
        />
        {/* <ChannelPublishingTier index={11} disabled={true} channelData={channelData} /> */}
        <ChannelSubscriptionType index={12} disabled={true} channelData={channelData} />
        {/* {authContext &&
          authContext.userRoles &&
          hasAnyRole(authContext.userRoles, [UserRole.Operator, UserRole.CreatorAdmin, UserRole.BrandAdmin]) &&
          authContext.myChannel?.status === ChannelState.ACTIVE && (
            <> */}

        {(channelData.subscriptionStatus === Tier.paid || channelData.subscriptionStatus === Tier.freeNpaid) && (
          <>
            <AddTextField
              index={13}
              id={"expectedMonthlySubscriptionPrice"}
              name={"expectedMonthlySubscriptionPrice"}
              title={"Monthly Price in USD"}
              note={"This is what subscribers will pay each month to access your paid content."}
              footNote="Enter a valid amount using numbers and a decimal (e.g. 1.99)."
              placeholder={"Expected monthly amount"}
              charAllowed={50}
              value={channelData.expectedMonthlySubscriptionPrice ?? ""}
              isCloseBtn={false}
              onChange={() => {}}
              showRemainingChar={false}
              disabled={true}
            />

            <AddTextField
              index={14}
              id={"expectedYearlySubscriptionPrice"}
              name={"expectedYearlySubscriptionPrice"}
              title={"Yearly Price in USD"}
              note={"This is what subscribers will pay each year to access your paid content."}
              footNote="Enter a valid amount using numbers and a decimal (e.g. 1.99)."
              placeholder={"Expected monthly amount"}
              charAllowed={50}
              onChange={() => {}}
              value={channelData.expectedYearlySubscriptionPrice ?? ""}
              isCloseBtn={false}
              showRemainingChar={false}
              disabled={true}
            />
            <OptionSelect
              index={15}
              title="Adjust Prices by Country"
              subTitle="Make your content more affordable for global audiences."
              value={channelData.adjustSubscriptionPriceByCountry ?? false}
              options={[
                { id: 1, title: "Yes", value: true, description: "Adjust prices by country’s pruchasing power." },
                { id: 2, title: "No", value: false, description: "Prices will remain the same worldwide, based on the USD amounts you set." },
              ]}
              onSelect={val => {}}
              disabled={true}
            />
          </>
        )}
        <ChannelSubscriptionIds
          index={16}
          disabled={channelData.status !== ChannelState.IN_REVIEW}
          channelData={channelData}
          updateChannelData={updateChannelData}
        />
        {/* </>
          )} */}
      </div>
    </>
  ) : (
    <></>
  );
};

// interface ChannelDetailProps {
//   channel: SKChannel;
// }
// export const ShowChannelDetail = ({ channel }: ChannelDetailProps) => {
//   return (
//     // <div className="absolute top-0 left-0 z-50 w-full h-full p-1 bg-white">

//     <div className="channel-page-context">
//       <div className="flex flex-col">
//         <div className="mb-[30px] flex flex-col w-full">
//           <EditStatusView />
//           {channel.id && <HistoryNavigator title="Channel Status" docId={channel.id} />}
//           {/* <StatusView /> */}
//           <div className="mb-[15px] flex flex-col min-w-[290px] min-h-[96px] max-w-[481px] max-h-[150px]">
//             {/* {progress > 0 && <progress value={progress} max="100" />} */}
//             {channel.backgroundImageUrl && (
//               <img
//                 className="min-w-[290px] min-h-[96px] max-w-[481px] max-h-[150px] bg-gray-700"
//                 style={{
//                   borderColor: "grey",
//                   borderWidth: "0.05rem",
//                   borderStyle: "solid",
//                   margin: "1px",
//                 }}
//                 //src="/icons/bannerimg.png"
//                 src={channel.backgroundImageUrl}
//                 alt=""
//               />
//             )}
//           </div>
//           <div className="mb-[10px] flex flex-col items-start min-w-[60px] min-h-[60px] max-w-[75px] max-h-[75px] rounded-full">
//             {/* {progress > 0 && <progress value={progress} max="100" />} */}
//             {channel.profileImageUrl && (
//               <img
//                 style={{
//                   borderColor: "grey",
//                   borderWidth: "0.05rem",
//                   borderStyle: "solid",
//                   margin: "1px",
//                   borderRadius: "6.375rem",
//                 }}
//                 //src="/icons/profileimg.png"
//                 src={channel.profileImageUrl}
//                 className="min-w-[60px] min-h-[60px] max-w-[75px] max-h-[75px] rounded-full"
//                 alt=""
//               />
//             )}
//           </div>
//           <div className="flex flex-col max-w-[480px]">
//             <div className="mb-[5px] flex flex-col w-full">
//               <label className="channel-preview-title">{channel.name}</label>
//             </div>
//             <div className="mb-[15px] flex flex-row w-full gap-[5px]">
//               <img src="/icons/VerificationBadge.png" alt="Saving" className="w-[22px] h-[22px]" />
//               <label className="channel-preview-verification">Verified</label>
//             </div>
//             <div className="mb-[5px] flex flex-col w-full">
//               <label className="capitalize channel-preview-topic-title">{channel.topic}</label>
//             </div>
//             <div className="mb-[30px] flex flex-col w-full">
//               <label className="channel-preview-topic-descptn">{channel.description}</label>
//             </div>
//           </div>

//           <div className="flex gap-[15px] flex-col w-full">
//             {/* <div className="flex flex-col w-full">
//                         <div className="mb-[5px] flex flex-col w-full">
//                           <label className="channel-preview-sub-topic-title">State</label>
//                         </div>
//                         <div className="flex flex-col w-full">
//                           <label className="channel-preview-sub-topic-value">
//                             {channel.status === ChannelState.IN_REVIEW
//                               ? "Channel under Review..."
//                               : "Published"}
//                           </label>
//                         </div>
//                       </div> */}
//             <div className="flex flex-col w-full">
//               <div className="mb-[5px] flex flex-col w-full">
//                 <label className="channel-preview-sub-topic-title">Age Rating</label>
//               </div>
//               <div className="flex flex-col w-full">
//                 <label className="channel-preview-sub-topic-value">Age {channel.age}+</label>
//               </div>
//             </div>
//             <div className="flex flex-col w-full">
//               <div className="mb-[5px] flex flex-col w-full">
//                 <label className="channel-preview-sub-topic-title">Language</label>
//               </div>
//               <div className="flex flex-col w-full">
//                 <label className="channel-preview-sub-topic-value">
//                   {getLanguageName(channel.language!) + ", " + getLanguageName(channel.secondLanguage!)}
//                 </label>
//               </div>
//             </div>
//             <div className="flex flex-col w-full">
//               <div className="mb-[5px] flex flex-col w-full">
//                 <label className="channel-preview-sub-topic-title">Country</label>
//               </div>
//               <div className="flex flex-col w-full">
//                 <label className="channel-preview-sub-topic-value">{getCountryName(channel.country!)}</label>
//               </div>
//             </div>
//             <div className="flex flex-col w-full">
//               <div className="mb-[5px] flex flex-col w-full">
//                 <label className="channel-preview-sub-topic-title">Last Published</label>
//               </div>
//               <div className="flex flex-col w-full">
//                 <label className="channel-preview-sub-topic-value">{format(channel.createdDate?.toDate() || new Date(), "MMM, dd yyyy")}</label>
//               </div>
//             </div>
//             <div className="flex flex-col w-full">
//               <div className="mb-[5px] flex flex-col w-full">
//                 <label className="channel-preview-sub-topic-title">Last Modified</label>
//               </div>
//               <div className="flex flex-col w-full">
//                 <label className="channel-preview-sub-topic-value">{format(channel.createdDate?.toDate() || new Date(), "MMM, dd yyyy")}</label>
//               </div>
//             </div>
//             <div className="flex flex-col w-full">
//               <div className="mb-[5px] flex flex-col w-full">
//                 <label className="channel-preview-sub-topic-title">Created</label>
//               </div>
//               <div className="flex flex-col w-full">
//                 <label className="channel-preview-sub-topic-value">{format(channel.createdDate?.toDate() || new Date(), "MMM, dd yyyy")}</label>
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* {channel && channel.userId && <Checklist userId={channel.userId} />} */}
//       </div>
//     </div>
//   );
// };

const checks = [
  {
    title: "Pay Enrollment Fee of USD 10.00",
    desc: "Enrollment fee is a one time non-refundable fee to get your onboarding process started.",
    linkTitle: "Enrollment Fee Paid",
  },
  {
    title: "Verify your Identity",
    desc: "ID verification helps us to keep the product safe and verify who you are.",
    linkTitle: "Verification Successful",
  },
  {
    title: "Submit Channel Application",
    desc: "Channel application lets us learn about you and the content you plan to publish.",
    linkTitle: "Channel Application Approved",
  },
  {
    title: "Sign Agreements",
    desc: "Review and sign Terms of Service, Privacy Policy, Acceptable Use Policy and Community Guidelines.",
    linkTitle: "Reviewed and Signed",
  },
  {
    title: "Sign up for Pro Subscription",
    desc: "Pro subscription allows you to publish content and get support.",
    linkTitle: "Pro Subscription Active",
  },
];

interface ChecklistProps {
  userId: string;
}

const StatusView = () => {
  const { channelData } = useContext(ModeratorChannelContext);
  const navigate = useNavigate();
  return (
    <div className="flex flex-col gap-[10px] ">
      <div className="text-base font-bold text-black">Channel State</div>

      <div
        className="flex flex-row items-center justify-between p-[15px] w-full max-w-[480px] border-[1px] border-bordergray rounded-lg mb-2 hover:cursor-pointer hover:border-gray-300"
        onClick={() => {
          channelData && navigate("../history", { state: { channelId: channelData.id } });
        }}
      >
        <div className="text-base">View Status History</div>
        <div className="flex text-skgray">
          {channelData && channelData.status === ChannelState.ACTIVE && (
            <span className="bg-skgreen w-[8px] h-[8px] min-h-2 min-w-2 rounded-full"></span>
          )}
          <p className="ml-1 capitalize">{channelData?.status ? getChannelStatusString(channelData?.status, channelData.subStatus) : ""}</p>
        </div>
      </div>
    </div>
  );
};

const EditStatusView = () => {
  const { channelData } = useContext(ModeratorChannelContext);
  const navigate = useNavigate();
  return (
    <>
      {channelData &&
        channelData.status === ChannelState.ACTIVE &&
        (channelData.subStatus === ChannelSubstate.EDIT_IN_DRAFT ||
          channelData.subStatus === ChannelSubstate.EDIT_REJECTED ||
          channelData.subStatus === ChannelSubstate.EDIT_IN_REVIEW) && (
          <div className="flex flex-col gap-[10px]">
            <div className="text-base font-bold text-black">Channel State</div>

            <div
              className="flex flex-row items-center justify-between p-[15px] w-full max-w-[480px] border-[1px] border-bordergray rounded-lg mb-2 hover:cursor-pointer hover:border-gray-300"
              onClick={() => {
                navigate("../history", {
                  state: { channelId: channelData.id },
                });
              }}
            >
              <div className="text-base">View Status History</div>
              <div className="flex text-skgray">
                {channelData && channelData.status === ChannelState.ACTIVE && (
                  <span className="bg-skgreen w-[8px] h-[8px] min-h-2 min-w-2 rounded-full"></span>
                )}
                <p className="ml-1 capitalize">{channelData?.status ? getChannelStatusString(channelData?.status, channelData.subStatus) : ""}</p>
              </div>
            </div>
          </div>
        )}
    </>
  );
};
// const StatusView = () => {
//   const { channelData, updateChannelData, setChannelId, channelId, loading } = useContext(ModeratorChannelContext);
//   const navigate = useNavigate();
//   return (
//     <>
//       <div className="text-gray-400 ">State</div>
//       <div className="relative w-full min-w-[200px] mb-2">
//         <div
//           className="flex flex-col px-3 w-full max-w-[400px] border-2 border-gray-200 rounded-lg mb-2 hover:cursor-pointer hover:border-gray-300"
//           onClick={() => {
//             navigate("../history", { state: { channelId } });
//           }}
//         >
//           <div className="flex space-x-2 mb-[15px]">
//             <div className="flex flex-row items-center text-lg font-bold">
//               {channelData && channelData.status === ChannelState.ACTIVE && (
//                 <span className="bg-skgreen w-[8px] h-[8px] min-h-2 min-w-2 rounded-full"></span>
//               )}
//               <p className="ml-1">{capitalizeFirstLetter(channelData?.status ?? "")}</p>
//             </div>
//           </div>
//           <div className="thinseparator" />
//           <div className="flex flex-row flex-1 p-2">
//             <div className="w-full">View History</div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

export const Checklist = ({ userId }: ChecklistProps) => {
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    const fetchUserInfo = async (id: string) => {
      const user = await getUser(id); // Fetch the document

      if (user) {
        if (user.onboarding) {
          if (user.onboarding.payment) {
            setCurrentStep(1);
          }
          if (user.onboarding.verification) {
            setCurrentStep(2);
          }
          if (user.onboarding.application) {
            setCurrentStep(3);
          }
          if (user.onboarding.aggreement) {
            setCurrentStep(4);
          }
          if (user.onboarding.subscription) {
            setCurrentStep(5);
          }
        }
      } else {
        console.log("No such document!");
        return null; // Handle the case where the document does not exist
      }
    };
    userId && fetchUserInfo(userId);
  }, [userId]);

  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-col gap-[15px] w-full">
        {checks.map((data, index) => (
          <div key={index} className="flex flex-col p-[20px] bg-white border-[1px] rounded-[18px] border-gray max-w-[550px] max-h[149px]">
            <div className="flex flex-row">
              <span className="inline-block bg-white rounded-full">
                <img src={`/icons/CheckItem.png`} className="object-contain w-[30px] h-[30px] min-w-5" alt="" />
              </span>
              <div className="flex flex-col w-full pl-[20px]">
                <h2 className="text-[#000000] channel-checklist-title">{data.title}</h2>
                <p className="text-[#8E8E93] channel-checklist-sub-title">{data.desc}</p>
                <div className="w-full thinseparator mt-[15px] mb-[15px]" />
                {currentStep === index ? (
                  <div className="float-left py-2 text-black">{data.linkTitle}</div>
                ) : (
                  <div className="text-skgreen channel-checklist-bottom-title">{data.linkTitle}</div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Checklist;
